function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import Text from '../Text';
import Description from './Description';
import FormGroup from './FormGroup';
import Label from './Label';
const TextFormGroup = /*#__PURE__*/memo(_ref => {
  let {
    description,
    label,
    value = '',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(FormGroup, null, !!label && /*#__PURE__*/React.createElement(Label, null, label), /*#__PURE__*/React.createElement(Text, _extends({
    my: 1
  }, props), value), !!description && /*#__PURE__*/React.createElement(Description, null, description));
});
TextFormGroup.propTypes = {
  ...Text.propTypes,
  label: PropTypes.string
};
TextFormGroup.displayName = 'TextFormGroup';
export default TextFormGroup;